// src/Footer.js
import React from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaArrowUp, FaWhatsapp } from 'react-icons/fa';
import logo1 from "../images/cira.png"

const Footer = () => {
  // Function to scroll the window to the top smoothly
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const whatsappNumber = "9840098717"; //98400 98717
  const whatsappMessage = encodeURIComponent("Hello! I am interested in your products and services.");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div style={{ color: "var(--main-red)", backgroundColor: "#ffffffff", borderTop: "2px solid var(--main-blue1)" }}>

      <section className="container py-5">
        <div className="row gy-4"> {/* Increased gap between rows on small screens */}

          {/* Corporate Office */}
          <div className="col-md-6">
            <h5 className="fw-semibold mb-3">CORPORATE OFFICE</h5>

            <p className=" small d-flex align-items-start mb-2" style={{ color: "var(--main-blue1)" }}>
              <FaMapMarkerAlt className="me-2 mt-1 flex-shrink-0" />
              #27, Ramasamy Street, Dheekshidhar Nagar, Hasthinapuram, Chrompet, Chennai – 600064
            </p>
            <hr className="border-secondary" />
            <a href="mailto:Sriarun@ciratechnology.com" className=" small d-flex align-items-center text-decoration-none mb-2" style={{ color: "var(--main-blue1)" }} >
              <FaEnvelope className="me-2" />
              Sriarun@ciratechnology.com
            </a>
            <a href="tel:+919840098717" className=" small d-flex align-items-center text-decoration-none" style={{ color: "var(--main-blue1)" }}>
              <FaPhoneAlt className="me-2" />
              +91 98400 98717
            </a>
          </div>

          {/* Regional Office */}
          <div className="col-md-6" >
            <h5 className="fw-semibold mb-3" >REGIONAL OFFICE</h5>
            {/* <p className=" fs-5 fw-bold">CIRA Technology Pvt Ltd</p> */}
            <p className=" small d-flex align-items-start mb-2" style={{ color: "var(--main-blue1)" }}>
              <FaMapMarkerAlt className="me-2 mt-1 flex-shrink-0" />
              #1, Amman Complex, Thindal Medu Busstop, Erode – 638012
            </p>
            <hr className="border-secondary" />
            <a href="mailto:Marimuthu@ciratechnology.com" className=" small d-flex align-items-center text-decoration-none mb-2 " style={{ color: "var(--main-blue1)" }}>
              <FaEnvelope className="me-2" />
              Marimuthu@ciratechnology.com
            </a>
            <a href="tel:+919486263651" className=" small d-flex align-items-center text-decoration-none" style={{ color: "var(--main-blue1)" }}>
              <FaPhoneAlt className="me-2" />
              +91 9486 263651
            </a>
          </div>
        </div>
      </section>

      {/* Footer Bottom */}
      <footer className="bg-dark text-secondary py-3 px-3">
        <div className="container-fluid d-flex flex-column flex-md-row justify-content-between align-items-center small">
          <div className="mb-2 mb-md-0 text-center text-md-start">
            Copyright © 2025
            <strong className="text-white mx-1">Cira Technology</strong>
            <span className="mx-2 d-none d-md-inline">|</span>
            All Rights Reserved
          </div>
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            <a href="#" className="text-secondary text-decoration-none">Privacy</a>
            <span>|</span>
            <a href="#" className="text-secondary text-decoration-none">Terms</a>
            <span>|</span>
            <a href="#" className="text-secondary text-decoration-none">FAQ’s</a>
          </div>
        </div>
      </footer>

      {/* Floating Action Buttons Container */}
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          zIndex: 1000,
        }}
      >
        {/* WhatsApp Button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact us on WhatsApp"
          className="btn rounded-circle shadow"
          style={{
            backgroundColor: '#25D366',
            color: '#ffffff',
            width: '42px',
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '22px',
            textDecoration: 'none',
          }}
        >
          <FaWhatsapp />
        </a>

        {/* Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="btn btn-danger rounded-circle shadow"
          style={{
            width: '42px',
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
          }}
        >
          <FaArrowUp />
        </button>
      </div>
    </div>
  );
};

export default Footer;